/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetAllRecruitmentResponse } from '../../entities/v1/GetAllRecruitmentResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1GetAllRecruitmentMetaModelSchema } from './getAllRecruitmentMetaModelSchema'
import { v1RecruitmentModelSchema } from './recruitmentModelSchema'
import { z } from 'zod'

export const v1GetAllRecruitmentResponseSchema = z.object({
  meta: z.lazy(() => v1GetAllRecruitmentMetaModelSchema),
  recruitment: z.array(z.lazy(() => v1RecruitmentModelSchema)),
}) as unknown as ToZod<V1GetAllRecruitmentResponse>